/**
 * React Query hooks for Capital Accounts data
 */

import { queryKeys, useApiQuery } from './index';
import { capitalAccountsService } from '@/services/capitalAccountsService';

/**
 * Hook for fetching fund capital accounts.
 *
 * Returns a fund-centric view showing all investors' capital metrics:
 * - Committed Capital
 * - Drawn Capital
 * - Undrawn Capital
 * - Fees & Costs
 * - Net Asset Value
 *
 * Plus fund totals summing all investors.
 *
 * @param fundId - UUID of the fund
 */
export function useFundCapitalAccounts(fundId: string) {
  return useApiQuery(
    queryKeys.capitalAccounts.fund(fundId),
    () => capitalAccountsService.getFundCapitalAccounts(fundId),
    {
      enabled: !!fundId,
    }
  );
}
